import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  RequestTypes,
  registerKeys,
} from '@core/react-query/features/registers/registers/register'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useUpdateRegisterUserPropertySettings = (
  options?: UseMutationOptions<
    any,
    RequestErrorType,
    RequestTypes['updateRegisterUserPropertySettings']
  >,
) => {
  const queryClient = useQueryClient()

  return useMutation({
    ...registerKeys.updateRegisterUserPropertySettings,
    ...options,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries(
        registerKeys.details({ registerId: data.registerId }),
      )
      queryClient.invalidateQueries(registerKeys.registerSettings._def)
    },
  })
}
